<template>
  <Head title="404" />
  <div class="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
    <div class="max-w-max mx-auto">
      <main class="sm:flex">
        <p class="text-4xl font-extrabold text-orange-500 sm:text-5xl">{{ status }}</p>
        <div class="sm:ml-6">
          <div class="sm:border-l sm:border-gray-200 sm:pl-6">
            <h1 class="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">{{ title }}</h1>
            <p class="mt-1 text-base text-gray-500">{{ description }}</p>
          </div>
          <div class="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
            <a href="https://darehealthinnovation.nl/" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-500 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"> Go back home </a>
            <a href="https://darehealthinnovation.nl/contact/" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-orange-500 hover:text-white bg-orange-100 hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"> Contact support </a>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import AuthLayout from "../../Shared/Layouts/AuthLayout";
import { Head } from "@inertiajs/inertia-vue3";
export default {
  layout: (h, page) => h(AuthLayout, () => page),

  components: {
    Head
  },

  props: {
    status: Number,
  },
  computed: {
    title() {
      return {
        503: 'Service Unavailable',
        500: 'Server Error',
        404: 'Page Not Found',
        403: 'Forbidden',
      }[this.status]
    },
    description() {
      return {
        503: 'Sorry, we are doing some maintenance. Please check back soon.',
        500: 'Whoops, something went wrong on our servers.',
        404: 'Please check the URL in the address bar and try again.',
        403: 'Sorry, you are forbidden from accessing this page.',
      }[this.status]
    },
  },
}
</script>
